import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import InputMask from 'react-input-mask';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const BusinessRank = () => {

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const { readData: getReports } = useEntityCrud('Report/RankBusiness');
    const { readData: getOpinions } = useEntityCrud('Opinions/getAll');
    const [opinion, setOpinion] = useState(0);
    const [isSearched, setIsSearched] = useState(false);
    const [opinions, setOpinions] = useState([]);
    const [rows, setRows] = useState([]);
    const [options, setOptions] = useState({});
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [cityId,setCityId] = useState(0);
    const [provinceId,setProvinceId] = useState(0);
    const {readGetDataById: getProvinces} = useEntityCrud('Info/GetProvinces');
    const {readGetDataById: getCities} = useEntityCrud(`Info/GetCities?provinceId=${provinceId}`);
    const [provinces,setProvinces] = useState([]);
    const [cities,setCities] = useState([]);

    const [isAdvanced, setIsAdvanced] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showItem, setShowItem] = useState(true);

    const [branchId, setBranchId] = useState([]);
    const [branchs, setBranchs] = useState([]);
    const { readData: getBranchs } = useEntityCrud('Branch/GetAllBranchs');

    useEffect(() => {

        getOpinions().then(({ data }) => {
            let opinionsArr = [];
            if (data.status)
                data.result.map(item => {
                    opinionsArr.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setOpinions(opinionsArr);
        })

        getBranchs().then(({ data }) => {
            let branchs = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })

        getProvinces().then(({data}) => {
            let getProvinces = [];
            const sorted = data.result.sort((a,b) => b.title < a.title)
            sorted.map(item => getProvinces.push({
                label: item.title,
                value: item.id
            }))
            setProvinces(getProvinces);
        })

    }, []);

    useEffect(() => {
        if(provinceId != 0)
            getCities().then(({data}) => {
                if(data.status){
                    let getCities = [];
                    const sorted = data.result.sort((a,b) => b.title < a.title)
                    sorted.map(item => getCities.push({
                        label: item.title,
                        value: item.id
                    }))
                    setCities(getCities);
                }
            });
    },[provinceId])

    const getReportsData = () => {
        setIsAdvanced(true);
        setLoading(true);
        setShowItem(false);
        const postedData = {
            p_opinion_id: opinion || 0,
            p_cityid: cityId,
            branchId: branchId

        };
        if(fromDate)
            postedData.p_fromdate = convertToGregorian(fromDate)
        if(toDate)
            postedData.p_todate = convertToGregorian(toDate)
        getReports(postedData).then(({ data }) => {
            setLoading(false)
            setShowItem(true);
            if (data.status && data.result) {
                let categories = [];
                let result = [];
                data.result.v_result.map(item => {
                    categories.push(`${item.business} (${item.cnt_use} نفر)`);
                    result.push(item.full_satisfaction);
                })
                setOptions({
                    chart: {
                        type: 'bar',
                        height: 3000
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                            },
                        }
                    },
                    colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
                        '#f48024', '#69d2e7'
                    ],
                    dataLabels: {
                        enabled: true,
                        offsetX: -6,
                        style: {
                            fontSize: '12px',
                            colors: ['#fff']
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val + '%'
                            }
                        }
                    },
                    stroke: {
                        show: true,
                        width: 1,
                        colors: ['#fff']
                    },
                    tooltip: {
                        shared: true,
                        intersect: false
                    },
                    title: {
                        text: opinions.find(op => op.value == opinion)?.label
                    },
                    xaxis: {
                        categories,
                        labels: {
                            formatter: function (val) {
                                return val + '%'
                            }
                        }
                    },
                });
                setRows([{ data: result }]);
            }
            else
                setRows([]);
        }).finally(() => {
            setIsSearched(true);
        })
    }

    const advancedSearch = e => {
        e.preventDefault();
        getReportsData();
        setIsAdvanced(true);
    }

    const resetAdvancedSearch = e => {
        e.preventDefault();
        setIsAdvanced(false);
        setIsSearched(false)

        setOpinion(0)
        setBranchId([])

        setOptions({});
        setRows({})
        setProvinceId(0)
        setCityId(0)
        setFromDate('')
        setToDate('')

    }


    return (
        <div className="row">
            <div className="col-md-2">
                <div className="form-group">
                    <label>نظرسنجی</label>
                    {opinion ? <i className="fe fe-x clear-select-btn" onClick={e => setOpinion(0)}></i> : ''}
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={opinions} value={opinions.filter(b => b.value == opinion)} onChange={e => setOpinion(e.value)} />
                </div>
            </div>

            <div className="col-md-2">
                <label>شرکت زیر مجموعه</label>
                <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={branchs} isMulti={true} value={branchs.filter(item => branchId.includes(item.value))} onChange={e => setBranchId([...e.map(i => i.value)])} />
            </div>

            <div className="col-md-2">
                <div className="form-group">
                    <label className="d-flex justify-content-between cursoer-pointer">
                        استان
                        {!!provinceId && <span className="text-primary" onClick={() => setProvinceId(0)}>حذف استان</span>}
                    </label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={provinces} value={provinces.filter(item => item.value == provinceId)} onChange={e => setProvinceId(e.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label className="d-flex justify-content-between cursoer-pointer">
                        شهر
                        {!!cityId && <span className="text-primary" onClick={() => setCityId(0)}>حذف شهر</span>}
                    </label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} disabled={!provinces.length} placeholder="انتخاب کنید" isDisabled={!cities.length} options={cities} value={cities.filter(item => item.value == cityId)} onChange={e => setCityId(e.value)} />
                </div>
            </div>
            
            <div className="col-md-2">
                <div className="form-group">
                    <label>از تاریخ</label>
                    {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                    <DatePicker
                        name="fromDate"
                        required
                        locale="fa"
                        shouldHighlightWeekends
                        value={fromDate}
                        onChange={setFromDate}
                        className="form-control"
                        inputPlaceholder='تاریخ  را انتخاب کنید ...'
                    />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>از تاریخ</label>
                    {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                    <DatePicker
                        name="toDate"
                        required
                        locale="fa"
                        shouldHighlightWeekends
                        value={toDate}
                        onChange={setToDate}
                        className="form-control"
                        inputPlaceholder='تاریخ  را انتخاب کنید ...'
                    />
                </div>
            </div>

            <div className="py-2 col-md-2" style={{ marginTop: 25, textAlign: "center" }}>
                {showItem && <> <button className="btn btn-primary" onClick={advancedSearch}>جستجو</button>
                    {isAdvanced &&
                        <button className="btn btn-danger mx-2" onClick={resetAdvancedSearch}>حذف فیلتر</button>
                    }
                </>
                }
            </div>

            {isLoading ?
                <div className="lds-facebook mt-4">
                    <div></div>
                    <div></div>
                    <div></div>
                </div > :

                <>

                    {rows.length ? <div className="col-md-12 mt-3">
                        <div id="chart" dir='ltr'>
                            <ReactApexChart options={options} series={rows} type="bar" height={5500} />
                        </div>
                    </div> : (isSearched ? <div className="col-md-12 mt-2"><div className="alert alert-primary"><p>داده ای جهت نمایش یافت نشد</p></div></div> : '')}
                </>
            }

        </div>
    )
}

export default BusinessRank;
